import React, {useContext} from "react";
import {motion} from "framer-motion";
import "./Education.scss";
import {educationInfo} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";
import {fadeUp, staggerCards, cardItem, vp} from "../../utils/animations";

export default function Education() {
  const {isDark} = useContext(StyleContext);
  if (!educationInfo.display) return null;

  return (
    <motion.section
      className={`edu ${isDark ? "dark" : ""}`}
      id="education"
      initial="hidden"
      whileInView="show"
      viewport={vp}
      variants={fadeUp}
    >
      <div className="edu__inner">
        <motion.div className="edu__header" variants={fadeUp}>
          <span className="section-label">Education</span>
          <h2 className="edu__title">Education</h2>
        </motion.div>

        <motion.div
          className="edu__list"
          variants={staggerCards}
          initial="hidden"
          whileInView="show"
          viewport={{once: true, amount: 0.05}}
        >
          {educationInfo.schools.map((school, i) => (
            <motion.div key={i} className="edu__item" variants={cardItem}>
              <div className="edu__logo-wrap">
                <img
                  src={school.logo}
                  alt={school.schoolName}
                  className="edu__logo"
                />
              </div>
              <div className="edu__body">
                <h3 className="edu__school">{school.schoolName}</h3>
                <p className="edu__degree">
                  {school.subHeader}
                  <span className="edu__sep">·</span>
                  <span className="edu__date">{school.duration}</span>
                </p>
                <p className="edu__desc">{school.desc}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </motion.section>
  );
}
